const it = {
    '/': {
        title: '{brand} | Scommesse Sportive, Casino Live & Prelievi Istantanei',
        description: 'Slot, casino live & scommesse sportive su {brand}. Casino crypto con prelievi istantanei, giochi equi & supporto 24/7.'
    },
    '/casino': {
        title: 'Casino Online | Slot, Blackjack & Dealer Live | {brand}',
        description: 'Slot, blackjack, roulette & dealer live su {brand}. Centinaia di giochi, depositi crypto veloci & prelievi istantanei disponibili 24/7.'
    },
    '/sports': {
        title: 'Scommesse Sportive Online | Scommesse Crypto & Quote | {brand}',
        description: 'Scommetti sullo sport su {brand}. Quote competitive su calcio, basket & altro. Scommesse live, puntate crypto sicure & pagamenti rapidi.'
    },
    '/livecasino': {
        title: 'Casino Live | Blackjack, Roulette & Dealer dal Vivo | {brand}',
        description: 'Blackjack, roulette & giochi di casino live su {brand}. Dealer reali, streaming HD & ampia selezione di tavoli live disponibili 24/7.'
    },
    '/slots': {
        title: 'Slot Online | Ampia Varietà di Slot da Casino | {brand}',
        description: "Un'enorme collezione di slot su {brand}. Macchine classiche, video slot & progressive, tutte giocabili con crypto."
    },
    '/vip': {
        title: 'Programma VIP | Premi Esclusivi & Vantaggi | {brand}',
        description: 'Il programma VIP di {brand}: premi esclusivi, bonus personalizzati e supporto prioritario. Vantaggi per i giocatori fedeli.'
    },
    '/welcome-offer': {
        title: 'Offerta di Benvenuto | Casino Crypto | {brand}',
        description: "Scopri l'offerta di benvenuto di {brand}. Inizia con le crypto e goditi vantaggi esclusivi per i nuovi giocatori."
    },
    '/referral': {
        title: 'Programma di Referral | Guadagna Premi | {brand}',
        description: 'Invita amici su {brand} e guadagna premi quando si iscrivono e soddisfano i requisiti.'
    },
    '/promotion-page': {
        title: 'Promozioni | Bonus & Offerte Speciali | {brand}',
        description: 'Tutte le promozioni attive su {brand}. Bonus, giri gratuiti e offerte speciali per i giocatori crypto.'
    },
    '/hotslots': {
        title: 'Slot Popolari | Slot Casino Più Giocate | {brand}',
        description: 'Gioca alle slot più popolari su {brand}. Le slot più calde disponibili con crypto.'
    },
    '/newgames': {
        title: 'Nuovi Giochi | Ultimi Giochi da Casino | {brand}',
        description: 'Scopri i più recenti giochi da casino su {brand}. Nuove slot, giochi live e giochi da tavolo aggiunti regolarmente.'
    },
    '/populargames': {
        title: 'Giochi Popolari | I Giochi da Casino Più Giocati | {brand}',
        description: 'I giochi da casino più popolari su {brand}. Dalle slot ai giochi live, tutto disponibile con crypto.'
    },
    '/gameshows': {
        title: 'Game Show | Casino con Show dal Vivo | {brand}',
        description: 'Goditi i migliori game show dal vivo su {brand}. Conduttori veri, giochi unici e grandi vincite in tempo reale.'
    },
    '/table_games': {
        title: 'Giochi da Tavolo | Blackjack, Roulette & Baccarat | {brand}',
        description: 'Gioca a blackjack, roulette, baccarat e altri giochi da tavolo su {brand}. Tutto disponibile con crypto.'
    },
    '/hotlive': {
        title: 'Casino Live Popolare | Giochi Live Più Giocati | {brand}',
        description: 'I giochi di casino live più popolari su {brand}. Gioca con veri dealer in tempo reale.'
    },
    '/featurebuyin': {
        title: 'Slot con Acquisto Bonus | Feature Buy-in | {brand}',
        description: 'Gioca a slot con la possibilità di acquistare il bonus su {brand}. Accedi direttamente al round bonus senza aspettare.'
    },
    '/originals': {
        title: 'Giochi Casino Originali | Titoli Esclusivi | {brand}',
        description: "Gioca a giochi originali esclusivi su {brand}. Titoli unici che non troverai da nessun'altra parte, sviluppati internamente per un'esperienza casino senza pari."
    },
    '/providers': {
        title: 'Fornitori di Giochi | Partner Studio & Software | {brand}',
        description: 'Esplora tutti i fornitori di giochi su {brand}. Collaboriamo con i migliori studi per offrirti una libreria crypto diversificata e di alta qualità.'
    },
    '/about-us': {
        title: 'Chi Siamo | Scopri di più su {brand}',
        description: 'Scopri {brand}, un casino crypto & sportsbook leader. Impegnati in un gioco sicuro, equo & emozionante con prelievi crypto istantanei.'
    },
    '/affiliate': {
        title: 'Programma Affiliati | Guadagna Crypto con {brand}',
        description: 'Diventa partner di {brand} & guadagna commissioni promuovendo il nostro casino crypto. Tariffe competitive, monitoraggio in tempo reale & supporto dedicato agli affiliati.'
    },
    '/faq': {
        title: 'FAQ | Domande Frequenti | {brand}',
        description: 'Trova risposte alle domande più comuni su {brand}. Consulta la nostra FAQ per aiuto con account, pagamenti, bonus & giochi da casino.'
    },
    '/aml-policy': {
        title: 'Politica AML | Antiriciclaggio su {brand}',
        description: 'La politica AML di {brand} garantisce un ambiente sicuro e affidabile. Leggi le nostre misure per prevenire attività illecite sulla nostra piattaforma.'
    },
    '/bonus-terms': {
        title: 'Termini e Condizioni dei Bonus | Promozioni {brand}',
        description: 'Leggi le regole dei bonus & promozioni di {brand}. Scopri come richiedere, utilizzare & ritirare le vincite dei bonus dalla nostra piattaforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Reclami e Arbitrato | Supporto Giocatori su {brand}',
        description: 'Scopri il processo di gestione dei reclami & risoluzione delle controversie di {brand}. Garantiamo un trattamento equo e risolviamo i problemi rapidamente e in modo trasparente.'
    },
    '/fairness': {
        title: 'Giochi Provabilmente Equi | Garanzia di Equità su {brand}',
        description: '{brand} utilizza la tecnologia provably fair per garantire che ogni risultato sia verificabile, trasparente & completamente casuale.'
    },
    '/fairness-overview': {
        title: 'Panoramica del Gioco Equo Verificabile | {brand}',
        description: "Il sistema provably fair di {brand} spiegato. Principi crittografici che garantiscono l'integrità del gioco & casualità completa in ogni risultato."
    },
    '/kyc-policy': {
        title: "Politica KYC | Verifica dell'Identità su {brand}",
        description: "La politica KYC di {brand} descrive il nostro processo di verifica dell'identità. Scopri come proteggiamo i giocatori e manteniamo un ambiente di gioco sicuro."
    },
    '/payment-policy': {
        title: 'Politica di Pagamento | Depositi & Prelievi in Crypto | {brand}',
        description: '{brand} accetta depositi & prelievi in crypto. Leggi la nostra politica di pagamento per limiti di transazione, criptovalute accettate & tempi di elaborazione.'
    },
    '/privacy-policy': {
        title: 'Informativa sulla Privacy | Protezione dei Dati su {brand}',
        description: "L'informativa sulla privacy di {brand}. Scopri come raccogliamo, utilizziamo & proteggiamo i tuoi dati personali sulla nostra piattaforma di casino crypto."
    },
    '/responsible-gaming': {
        title: 'Gioco Responsabile | Gioca in Sicurezza su {brand}',
        description: '{brand} è impegnata nel gioco responsabile. Accedi a strumenti & risorse per gestire le tue abitudini di gioco e giocare in sicurezza.'
    },
    '/terms-of-service': {
        title: 'Termini di Servizio | {brand}',
        description: "Consulta i termini & condizioni che regolano l'utilizzo di {brand}. Comprendi i tuoi diritti e responsabilità come giocatore."
    },
    '/terms-sports': {
        title: 'Termini e Condizioni delle Scommesse Sportive | {brand}',
        description: 'I termini & condizioni delle scommesse sportive di {brand}. Regole per piazzare scommesse, riscuotere vincite & utilizzare lo sportsbook sulla nostra piattaforma.'
    }
};
export default it;
